import { render, staticRenderFns } from "./MeetingBadge.vue?vue&type=template&id=2f00c146&"
import script from "./MeetingBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./MeetingBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports